export enum TipoOrigemProtocoloEnum {
  EXTERNO = 'EXTERNO',
  OUVIDORIA = 'OUVIDORIA',
  GERAL = 'GERAL'
}

export const tipoOrigemFormatada = {
  EXTERNO: 'Externo',
  OUVIDORIA: 'Ouvidoria',
  GERAL: 'Geral'
};
